"use strict";

module.exports = {
  strings: {
    pluginNameBox: 'Box'
  }
};